import { all, call, put, takeLatest } from "redux-saga/effects";
import { AxiosCall } from "../../../utils/axios";
import * as actions from "./actions";


function* fetchBanners() {
    try {
        const result = yield call(AxiosCall, `/resources/get_banners/`);
        yield put(actions.fetchBannersSuccess(result.data.results))
    } catch (e) {
        yield put(actions.fetchBannersFailure(e))
    }
}


export default function* rootSaga() {
    yield all([
        // Watchers Articles
        takeLatest(actions.FETCH_BANNERS.REQUEST, fetchBanners),
    ])
}

